"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.page = void 0;
var classnames_1 = require("classnames");
var React = require("react");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var ResourcePage_1 = require("@/pages/common/components/ResourcePage");
var styles_1 = require("@/pages/newsAndInsights/styles");
var styles_2 = require("@/pages/guides/styles");
var GuideSearch_1 = require("@/pages/guides/components/GuideSearch/GuideSearch");
var DistrictListing_1 = require("@/pages/guides/components/DistrictListing/DistrictListing");
var GuideListing_1 = require("@/pages/guides/components/GuideListing/GuideListing");
var actions_1 = require("@/pages/guides/actions/actions");
var core_1 = require("@material-ui/core");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var mapStateToProps = function (state) { return (__assign(__assign({}, state), { resourceMenu: state.layout.menulist.filter(function (it) { return it.page === Pages_1.Pages.RESOURCES; })[0] })); };
var mapDispatchToProps = function (dispatch) { return ({
    changePage: function (page) { return dispatch(actions_1.default.changePage(page)); },
    setSearchKeywords: function (values) { return dispatch(actions_1.default.setSearchKeywords(values)); },
    setSearchText: function (value) { return dispatch(actions_1.default.setSearchText(value)); },
    searchGuides: function () { return dispatch(actions_1.default.searchGuides()); },
}); };
exports.page = function (props) {
    var menu = props.menu, headerSection = props.headerSection, subHeaderSection = props.subHeaderSection, searchSection = props.searchSection, guides = props.guides, guidesDistricts = props.guidesDistricts, changePage = props.changePage, setSearchKeywords = props.setSearchKeywords, setSearchText = props.setSearchText, searchGuides = props.searchGuides;
    var pager = guides.pager, t = guides.translate;
    var headStyle = {
        backgroundImage: 'url(/res/img/skyline_hk.jpg)',
        backgroundSize: 'center 23%',
        backgroundAttachment: 'unset',
    };
    var formStyle = {
        overflowX: 'hidden',
    };
    var formClass = 'c-ssection__block c-ssection__block--noflex l-container__mfull';
    var currentPage = Pages_1.Pages.GUIDES;
    var language = props.layout.language.languages
        .filter(function (it) { return it.id === props.layout.language.current; })[0];
    var languageCode = language.code1;
    var renderPagination = function (pager) {
        var onGotoPrevPage = function () {
            changePage(pager.currentPage - 1);
        };
        var onGotoNextPage = function () {
            changePage(pager.currentPage + 1);
        };
        var renderPrevPage = function () {
            if (pager.currentPage === 1)
                return '';
            return (React.createElement("a", { onClick: onGotoPrevPage, className: "c-pagination__item" },
                React.createElement("span", null, t.previous)));
        };
        var renderNextPage = function () {
            if (pager.currentPage === pager.totalPages)
                return '';
            return (React.createElement("a", { onClick: onGotoNextPage, className: "c-pagination__item" },
                React.createElement("span", null, t.next)));
        };
        var renderPage = function (i, current) {
            var goToPage = function (e) {
                e.preventDefault();
                changePage(i + 1);
                return false;
            };
            var classes = classnames_1.default([
                'c-pagination__item',
                'c-pagination__item--number',
                {
                    'c-pagination__item--current': i === current,
                },
            ]);
            if (i === current) {
                return (React.createElement("span", { key: i, className: classes }, i + 1));
            }
            var getPagedUrl = function (n) {
                // tslint:disable-next-line: max-line-length
                return "/" + languageCode + "/property-news/?pno=" + n;
            };
            var pageUrl = getPagedUrl(i + 1);
            return (React.createElement("a", { key: i, onClick: goToPage, className: "c-pagination__item c-pagination__item--number", href: pageUrl },
                React.createElement("span", null, i + 1)));
        };
        var renderPages = function () {
            var pages = [];
            for (var i = 0; i < pager.totalPages; i = i + 1) {
                pages.push(renderPage(i, pager.currentPage - 1));
            }
            pages = pages.slice(pager.currentPage - 1, pager.currentPage + 4 >= pager.totalPages ?
                pager.totalPages - 1 :
                pager.currentPage + 4);
            if (pager.currentPage > 2) {
                pages.unshift((React.createElement("span", { key: "pred", className: "c-pagination__item c-pagination__item--number" }, "...")));
            }
            if (pager.currentPage !== 1) {
                pages.unshift(renderPage(0, -1));
            }
            if (pager.currentPage < pager.totalPages - 5) {
                pages.push((React.createElement("span", { key: "postd", className: "c-pagination__item c-pagination__item--number" }, "...")));
            }
            if (pager.currentPage <= pager.totalPages) {
                pages.push(renderPage(pager.totalPages - 1, pager.currentPage - 1));
            }
            return pages;
        };
        if (pager.totalPages <= 1) {
            return null;
        }
        return (React.createElement("div", { className: "c-pagination u-text-center l-pad-around--2", style: { marginTop: 20 } },
            renderPrevPage(),
            React.createElement("div", { className: "c-pagination__items" }, renderPages()),
            renderNextPage()));
    };
    var renderHeader = function () {
        var title = subHeaderSection.title, paragraph = subHeaderSection.paragraph;
        if (title && paragraph) {
            return (React.createElement(styles_1.Header, { className: "c-page-header", style: { marginBottom: 0 } },
                React.createElement("div", { className: "c-page-header__body" },
                    React.createElement(styles_1.Paragraph, null, subHeaderSection.paragraph))));
        }
    };
    var renderTitle = function () {
        var title = subHeaderSection.title, keyword = subHeaderSection.keyword, translate = subHeaderSection.translate;
        var keywordText = translate.keyword;
        if (title) {
            return React.createElement(styles_2.SectionTitle_B, null, title);
        }
        if (keyword) {
            return React.createElement(styles_2.SectionTitle_B, null, keywordText + " " + keyword);
        }
        return null;
    };
    var renderDistricts = function () {
        if (guidesDistricts.districts) {
            return (React.createElement(DistrictListing_1.DistrictListing, { guidesDistricts: guidesDistricts }));
        }
        return null;
    };
    var renderGuides = function () {
        if (guides !== null) {
            if (guides.items && guides.items.length > 0) {
                return (React.createElement(GuideListing_1.GuideListing, { guides: guides }));
            }
            // to avoid no result appears when entering this page 
            // because is no default loaded articles in Hong Kong Distrct Guides section there
            if (guidesDistricts && guidesDistricts.districts !== null) {
                return null;
            }
            return t.noResults;
        }
        return null;
    };
    var renderMenuItems = function () {
        var items = [{
                name: headerSection.translate.selectGuide,
                url: 'select',
            }];
        menu.map(function (item) {
            var name = item.name, subItems = item.subItems;
            items = __spreadArrays(items, [
                {
                    name: name,
                    url: '',
                }
            ], subItems);
        });
        return items.map(function (item) {
            var option = item.name;
            if (item.url === '')
                option = "---" + option + "---";
            else if (item.url !== 'select')
                option = "" + option;
            return (
            // tslint:disable-next-line: jsx-key
            React.createElement("option", { key: item.name, value: item.url, disabled: item.url === '' || item.url === 'select' }, option));
        });
    };
    var menuItemSelected = function (e) {
        window.location = e.target.value;
    };
    var guideMenuItems = __spreadArrays(menu);
    return (React.createElement(ResourcePage_1.default, { title: headerSection.translate.title, headStyle: headStyle, currentPage: currentPage, menu: props.resourceMenu, guideMenuItems: guideMenuItems },
        React.createElement("div", { className: "c-ssection c-ssection--simple" },
            React.createElement("div", { className: formClass, style: { paddingBottom: 0 } },
                React.createElement(GuideSearch_1.GuideSearch, { searchSection: searchSection, setSearchKeywords: setSearchKeywords, setSearchText: setSearchText, searchGuides: searchGuides })),
            React.createElement("div", { id: "guides", className: formClass, style: formStyle },
                React.createElement(core_1.Hidden, { smUp: true },
                    React.createElement(styles_2.MenuSelect, { value: "select", onChange: menuItemSelected }, renderMenuItems())),
                renderTitle(),
                renderHeader(),
                renderDistricts(),
                renderGuides(),
                pager && renderPagination(pager))),
        React.createElement(ServerSideSchema_1.default, null)));
};
var enhance = redux_1.compose(react_redux_1.connect(mapStateToProps, mapDispatchToProps));
exports.default = enhance(exports.page);
